import SimpleModal from "cpl-react-common/components/Modals/SimpleModal";
import { useDispatch, useSelector } from "react-redux";
import {
  resendUserInvitiations,
  selectIsLoading,
  selectShowResendResults,
  setShowResendResults,
} from "./UsersMigrationSlice";
import { Permission } from "services/userSession/UserPermittedComponent";
import { Permissions } from "cpl-react-common/components/Enums/Permissions";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersMedical } from "@fortawesome/pro-solid-svg-icons";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { YesNoAlert } from "cpl-react-common/components/Alerts/YesNo";
import { Style } from "cpl-react-common/Helpers/AlertHelpers";
import { useState } from "react";

const ResendUserInvitationsButton: React.FC = () => {
  const dispatch = useDispatch();
  const thunkDispatch = useThunkDispatch();
  const showResultsModal = useSelector(selectShowResendResults);
  const isLoading = useSelector(selectIsLoading);
  const [showConfirm, setShowConfirm] = useState(false);

  function handleConfirmAnswer(answer: boolean) {
    setShowConfirm(false);
    if (answer) thunkDispatch(resendUserInvitiations());
  }
  return (
    <Permission permissionPredicate={(permission) => permission === Permissions.AddUsers}>
      <YesNoAlert
        data-test-id="user-table__resend-invitations-alert"
        showAlert={showConfirm}
        alertTitle="Resend Invitations"
        alertText="Are you sure you want to resend invitations to all invited users who have not yet accessed their account?"
        callBack={handleConfirmAnswer}
        style={Style.Warning}
      />
      <SimpleModal
        showModal={showResultsModal}
        modalTitle="Migration Results"
        dismissModalCallback={() => {
          dispatch(setShowResendResults(false));
        }}
      >
        <p>
          Connect invitations have been resent to all previously invited users who have not yet accessed their account
        </p>
      </SimpleModal>
      <button
        data-test-id="user-table__resend-button"
        className={"btn btn-primary"}
        onClick={() => setShowConfirm(true)}
        disabled={isLoading}
      >
        <ActivityIndicator isBusy={isLoading}>
          <FontAwesomeIcon icon={faUsersMedical} /> Resend Invitations
        </ActivityIndicator>
      </button>
    </Permission>
  );
};

export default ResendUserInvitationsButton;
